import { Route, Routes } from 'react-router-dom';
import Cm1ArchiveView from 'neo-office/Cm1Archive';
import 'neo-office/neo-office.css';

export const Cm1Archive = () => (
  <Routes>
    <Route
      path="/"
      element={
        <div
          className="neo"
          style={{
            display: 'block',
            minHeight: 'auto',
            padding: 0,
            background: 'transparent',
          }}
        >
          <Cm1ArchiveView />
        </div>
      }
    />
  </Routes>
);
